import React from 'react';
import Audition from './Audition';
import AmateurAuditionsForm from './AmateurAuditionsForm';
import LoadMore from '../generalComponents/LoadMore';

class Auditions extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      toggleAmateurAuditionForm: false
    };
  }

  openAmateurAuditionForm = () => {
    this.setState({toggleAmateurAuditionForm: !this.state.toggleAmateurAuditionForm});
  }

    render() {
      const { auditions, loadMore, isLoading, handleArchiveClick } = this.props;

      return (
        <div className="content soft-white" id="audition_index_view">
            <div className="container">
                <div className="top-section text-center">
                  <div className="audition-form-toggle-container container">
                    <h1>Do You Want to be a Naked News Anchor?</h1>
                    <button onClick={this.openAmateurAuditionForm}>Click Here!</button>
                    {this.state.toggleAmateurAuditionForm ? <AmateurAuditionsForm /> : null}
                  </div>
                    <h1 className="top-title">
                      Amateur Auditions
                    </h1>
                    <p className="top-description">
                        Find out if these girls have what it takes to become the next Naked News anchor!
                    </p>
                </div>
                <div className="row-r content-flex auditions">
                    {
                      auditions.map( (audition, index) => (
                        <Audition
                          key={index}
                          audition={audition}
                          handleArchiveClick={handleArchiveClick}
                        />
                      ))
                    }
                </div>

                <LoadMore
                  loadMore={loadMore}
                  isLoading={isLoading}
                />

            </div>
        </div>
      );
    }
}
export default Auditions;
